import { render, staticRenderFns } from "./InstitutionalVideo.vue?vue&type=template&id=4e2bffa0&"
import script from "./InstitutionalVideo.vue?vue&type=script&lang=js&"
export * from "./InstitutionalVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports